export default __webpack_public_path__ + "static/upper1_1-9061b716d8195f34a149f9fd63cd934c.jpg";